<template>
  <v-dialog
    persistent
    v-model="showModal"
    persistent
    max-width="600"
  >
    <v-btn
      color="error"
      slot="activator"
    >
      Apply default settings
    </v-btn>

    <v-card>
      <v-card-title
        class="headline red lighten-2"
        primary-title
      >
        Warning!
      </v-card-title>

      <v-layout justify-center column px-3 pt-3>
        <h3>Are you sure that you want to apply default settings?</h3>
        <p>You will remove all of your custom style settings. This action cannot be undone!</p>
      </v-layout>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          flat
          @click="applyDefaultSettings"
        >
          Apply
        </v-btn>
        <v-btn
          color="primary"
          @click="closeModal"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ApplyDefaultSettings',
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    ...mapActions(['resetStyleSettings']),
    closeModal () {
      this.showModal = false
    },
    async applyDefaultSettings () {
      try {
        await this.resetStyleSettings()
      } catch (err) {
        console.error(err)
      } finally {
        this.closeModal()
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/ApplyDefaultSettings.vue